import { render, staticRenderFns } from "./Integrations.vue?vue&type=template&id=514bb362&"
import script from "./Integrations.vue?vue&type=script&lang=ts&"
export * from "./Integrations.vue?vue&type=script&lang=ts&"
import style0 from "./Integrations.vue?vue&type=style&index=0&id=514bb362&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports